<tui-root>


    <main class="px-0 md:px-8 xl:px-0 py-16">
        <section *ngIf="currentSurveyStep === 1">
            <section id="dashboard" class="mx-auto max-w-screen-xl prose leading-normal">
                <div class="container">
                    <div class="dashboard__intro">
                        <h1 class="header-hex-bar">
                            <span class="hidden sm:inline-block">Program Schedule</span>
                            <span class="inline-block sm:hidden">Schedule</span>
                        </h1>
                        <p class="text-center"><em>As the growing season progresses, we'll ask for your observations
                                about
                                Storen's performance in your fields.</em> Your feedback helps us ensure you achieve the
                            best
                            possible results with our products.</p>
                        <p class="text-center"><em>Ready to begin?</em> Follow the step-by-step guide below to get
                            started.
                            Once
                            you complete a step, the next one will unlock when it's time.</p>
                    </div>
                </div>

                <div class="program-schedule__details md:container my-16">
                    <table>
                        <tr>
                            <td class="text-alignment text-[26px]">Spring:</td>
                            <td class="text-alignment text-[22px] sm:text-[24px] leading-snug">
                                {{applicationCheckinData?.Description}}
                            </td>
                            <td>
                                <ng-container *ngIf="applicationLockSatus=='COMPLETED'">
                                    <button tuiButton appearance="" iconEnd="@tui.circle-check" size="m"
                                        class="p-[10px] rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-completed pointer-events-none">
                                        Completed
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="applicationLockSatus=='GETSTARTED' || applicationLockSatus=='GETSTARTEDDISABLE'">
                                    <button tuiButton appearance="" iconEnd="@tui.circle-arrow-right" size="m"
                                    (click)="getStarted(2)" [disabled]="applicationLockSatus=='GETSTARTEDDISABLE'" [ngClass]="applicationLockSatus=='GETSTARTEDDISABLE'? 'pointer-events-none': ''"
                                    class="p-[10px] blue-hover-effect rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-dark-blue">
                                    Get Started
                                </button>
                                </ng-container>
                                <ng-container *ngIf="applicationLockSatus=='LOCK'">
                                    <button tuiButton appearance="" size="m"
                                    class="p-[10px] rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-BEBEBE pointer-events-none">
                                    Locked
                                    <img src="../assets/Lock.svg" alt="Lock">
                                </button>
                                </ng-container>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-alignment text-[26px]">Summer:</td>
                            <td class="text-alignment text-[22px] sm:text-[24px] leading-snug">
                                {{satisfactionsurveyData?.Description}}</td>
                            <td>
                                <ng-container *ngIf="satisfactionSurveyStatus=='COMPLETED'">
                                    <button tuiButton appearance="" iconEnd="@tui.circle-check" size="m"
                                        class="p-[10px] rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-completed pointer-events-none">
                                        Completed
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="satisfactionSurveyStatus=='GETSTARTED' || satisfactionSurveyStatus=='GETSTARTEDDISABLE'">
                                    <button tuiButton appearance="" iconEnd="@tui.circle-arrow-right" size="m" [ngClass]="satisfactionSurveyStatus=='GETSTARTEDDISABLE'? 'pointer-events-none': ''"
                                    (click)="getStarted(3)" [disabled]="satisfactionSurveyStatus=='GETSTARTEDDISABLE'"
                                    class="p-[10px] blue-hover-effect rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-dark-blue">
                                    Get Started
                                </button>
                                </ng-container>
                                <ng-container *ngIf="satisfactionSurveyStatus=='LOCK'">
                                    <button tuiButton appearance="" size="m"
                                    class="p-[10px] rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-BEBEBE pointer-events-none">
                                    Locked
                                    <img src="../assets/Lock.svg" alt="Lock">
                                </button>
                                </ng-container>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-alignment text-[26px]">Summer:</td>
                            <td class="text-alignment text-[22px] sm:text-[24px] leading-snug">
                                {{cleanRowPhotos?.Description}}
                            </td>
                            <td>
                                <ng-container *ngIf="cleanRowPhotosStatus=='COMPLETED'">
                                    <button tuiButton appearance="" iconEnd="@tui.circle-check" size="m"
                                        class="p-[10px] rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-completed pointer-events-none">
                                        Completed
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="cleanRowPhotosStatus=='GETSTARTED' || cleanRowPhotosStatus=='GETSTARTEDDISABLE'">
                                    <button tuiButton appearance="" iconEnd="@tui.circle-arrow-right" size="m" [ngClass]="cleanRowPhotosStatus=='GETSTARTEDDISABLE'? 'pointer-events-none': ''"
                                    (click)="getStarted(4)" [disabled]="cleanRowPhotosStatus=='GETSTARTEDDISABLE'"
                                    class="p-[10px] blue-hover-effect rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-dark-blue">
                                    Get Started
                                </button>
                                </ng-container>
                                <ng-container *ngIf="cleanRowPhotosStatus=='LOCK'">
                                    <button tuiButton appearance="" size="m"
                                    class="p-[10px] rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-BEBEBE pointer-events-none">
                                    Locked
                                    <img src="../assets/Lock.svg" alt="Lock">
                                </button>
                                </ng-container>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-alignment text-[26px]">Fall:</td>
                            <td class="text-alignment text-[22px] sm:text-[24px] leading-snug">
                                {{endOfSeasonSurvey?.Description}}</td>
                            <td>
                                <ng-container *ngIf="endOfSeasonSurveyStatus=='COMPLETED'">
                                    <button tuiButton appearance="" iconEnd="@tui.circle-check" size="m"
                                        class="p-[10px] rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-completed pointer-events-none">
                                        Completed
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="endOfSeasonSurveyStatus=='GETSTARTED' ||  endOfSeasonSurveyStatus=='GETSTARTEDDISABLE' ">
                                    <button tuiButton appearance="" iconEnd="@tui.circle-arrow-right" size="m" [ngClass]="endOfSeasonSurveyStatus=='GETSTARTEDDISABLE'? 'pointer-events-none': ''"
                                    (click)="getStarted(5)" [disabled]="endOfSeasonSurveyStatus=='GETSTARTEDDISABLE'"
                                    class="p-[10px] blue-hover-effect rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-dark-blue">
                                    Get Started
                                </button>
                                </ng-container>
                                <ng-container *ngIf="endOfSeasonSurveyStatus=='LOCK'">
                                    <button tuiButton appearance="" size="m"
                                    class="p-[10px] rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-BEBEBE pointer-events-none">
                                    Locked
                                    <img src="../assets/Lock.svg" alt="Lock">
                                </button>
                                </ng-container>
                            </td>
                        </tr>
                    </table>
                </div>
            </section>

            <section class="relative bg-cover bg-center py-12 text-white rewards-bg-image">

                <div class="absolute inset-0 bg-black/75"></div>

                <div class="container relative z-10 max-w-screen-xl">
                    <div class="dashboard__intro">
                        <h1 class="header-hex-bar"><span class="inline-block">REWARDS</span></h1>
                        <p class="text-center mt-5">Throughout the season, you'll have a chance to unlock rewards.</p>
                    </div>

                    <div class="flex justify-center flex-col md:flex-row gap-10 mt-5">
                        <div
                            class="max-w-6xl mx-auto flex items-start md:items-center justify-center gap-3 md:gap-10 relative">
                            <div class="flex flex-col items-center w-[150px] md:w-[263px] text-center">
                                <div
                                    class="w-full h-[150px] md:h-[263px] rounded-full flex items-center justify-center bg-gray-300">
                                    <img src="../assets/speaker.png" alt="Reward 1"
                                        class="w-[130px] h-[84px] md:w-48 md:h-48 object-contain">
                                </div>
                                <p class="mt-4 md:text-[26px]/7 text-[16px] font-bold">SONOSPHEAR<sup>&trade;</sup><br>wireless speaker</p>
                            </div>

                            <div class="flex flex-col items-center absolute md:bottom-[90px] bottom-[50px]">
                                <img src="../assets/Polygon 4.svg" class="w-[24px] h-[24px] mb-1" alt="">
                                <div class="text-white font-bold test-[20px] md:text-[28px]">
                                    OR
                                </div>
                            </div>

                            <div class="flex flex-col items-center w-[150px] md:w-[263px] text-center">
                                <div
                                    class="w-full h-[150px] md:h-[263px] rounded-full flex items-center justify-center bg-gray-300">
                                    <img src="../assets/wallet.png" alt="Reward 2"
                                        class="w-[130px] h-[84px] md:w-48 md:h-48 object-contain">
                                </div>
                                <p class="mt-4 md:text-[26px]/7 text-[16px] font-bold">The
                                    Ridge<sup>&reg;</sup><br>wallet</p>
                            </div>
                        </div>

                        <!-- Vertical Border on Desktop -->
                        <div class="hidden lg:flex w-[6px] h-[372px] bg-[#B78B1E]"></div>

                        <!-- Horizontal Border on Mobile -->
                        <div class="lg:hidden w-full h-[6px] bg-[#B78B1E] my-10"></div>

                        <div
                            class="max-w-6xl mx-auto flex items-start md:items-center justify-center gap-3 md:gap-10 relative">
                            <div class="flex flex-col items-center w-[150px] md:w-[263px] text-center">
                                <div
                                    class="w-full h-[150px] md:h-[263px] rounded-full flex items-center justify-center bg-gray-300">
                                    <img src="../assets/hat.png" alt="Reward 3"
                                        class="w-[130px] h-[84px] md:w-48 md:h-48 object-contain">
                                </div>
                                <p class="mt-4 md:text-[26px]/7 text-[16px] font-bold">Storen<br>branded hat</p>
                            </div>

                            <div class="flex flex-col items-center absolute md:bottom-[90px] bottom-[50px]">
                                <img src="../assets/Polygon 4.svg" class="w-[24px] h-[24px] mb-1" alt="">
                                <div class="text-white font-bold test-[20px] md:text-[28px]">
                                    OR
                                </div>
                            </div>

                            <div class="flex flex-col items-center w-[150px] md:w-[263px] text-center">
                                <div
                                    class="w-full h-[150px] md:h-[263px] rounded-full flex items-center justify-center bg-gray-300">
                                    <img src="../assets/beanie.png" alt="Reward 4"
                                        class="w-[130px] h-[84px] md:w-48 md:h-48 object-contain">
                                </div>
                                <p class="mt-4 md:text-[26px]/7 text-[16px] font-bold">Storen branded<br>beanie</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="mt-5 container max-w-screen-xl">
                <div class="dashboard__intro">
                    <h1 class="header-hex-bar"><span class="inline-block">Resources</span></h1>
                </div>

                <div class="flex md:flex-row flex-col items-center justify-between gap-10 mt-5 mx-auto max-w-6xl">
                    <div class="program-sheet-resources-1" (click)="downloadImage('https://assets.syngentaebiz.com/pdf/media/storen-satisfaction-program-sheet.pdf', '2025_SSP_Program_Sheet_Page_1 1.pdf')"></div>
                    <p class="text-[24px] text-center">Download the Storen Satisfaction Program Sheet.</p>
                    <button tuiButton appearance="" size="m"
                        class="p-[10px] blue-hover-effect rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-dark-blue"
                        (click)="downloadImage('https://assets.syngentaebiz.com/pdf/media/storen-satisfaction-program-sheet.pdf', '2025_SSP_Program_Sheet_Page_1 1.pdf')">
                        Download
                    </button>
                </div>
                <div
                    class="flex md:flex-row flex-col items-center justify-between gap-10 mt-10 md:mt-5 mx-auto max-w-6xl">
                    <div class="program-sheet-resources-2" (click)="downloadImage('https://assets.syngentaebiz.com/pdf/media/storen-satisfaction-terms-and-conditions.pdf', '2025_SSP_Program_Sheet_Page_1 2.pdf')"></div>
                    <p class="text-[24px] text-center">Download the Program Terms & Conditions.</p>
                    <button tuiButton appearance="" size="m"
                        class="p-[10px] blue-hover-effect rounded-0 w-full md:w-[226px] text-[26px] font-bold text-[#FFFFFF] bg-dark-blue"
                        (click)="downloadImage('https://assets.syngentaebiz.com/pdf/media/storen-satisfaction-terms-and-conditions.pdf', '2025_SSP_Program_Sheet_Page_1 2.pdf')">
                        Download
                    </button>
                </div>
            </section>
        </section>
    </main>

</tui-root>